import { FirestoreDataConverter } from 'firebase/firestore';

export default class ConditionUnit {
  constructor (
    readonly id: string,
    readonly name: string,
    readonly unitType: string,
    readonly level: number,
    readonly parentId: string,
    readonly fieldCode: string,
    readonly fieldType: string,
    readonly operation: string,
    readonly targetValue: string,
    readonly visibleFieldCodes: string[],
  ) {}

  toString() {
    return `${this.unitType}`;
  }
}

export const CONDITION_UNIT = 'condition_units';
export const conditionUnitConverter: FirestoreDataConverter<ConditionUnit> = {
  toFirestore: (conditionUnit) => {
    return {
      name: conditionUnit.name,
      unitType: conditionUnit.unitType,
      level: conditionUnit.level,
      parentId: conditionUnit.parentId,
      fieldCode: conditionUnit.fieldCode,
      fieldType: conditionUnit.fieldType,
      operation: conditionUnit.operation,
      targetValue: conditionUnit.targetValue,
      visibleFieldCodes: conditionUnit.visibleFieldCodes,
    };
  },

  fromFirestore: (snapshot, options) => {
    const data = snapshot.data(options);
    return new ConditionUnit(snapshot.id,
      data.name,
      data.unitType,
      data.level,
      data.parentId,
      data.fieldCode,
      data.fieldType,
      data.operation,
      data.targetValue,
      data.visibleFieldCodes
    );
  }
};
